import React from 'react';
import TpClientPaymentItem from '../../../Domain/TpClientPaymentItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';

export default class CreateTpClientPaymentWindowDescription extends React.Component {
  static titleForCreate = 'Add New Client Payment';
  static itemType = TpClientPaymentItem;
  static serviceFunction = (edited) => TpClientPaymentService.CreateClientPayment(edited, null, false, null);
  static navigateToOnCreation = '/new_clientpaymentdetails?id=';

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-6',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
          onFieldChange: CreateTpClientPaymentWindowDescription.onClientChange,
          showFilterAt: (editItem) => (editItem.staticClient !== 0 ? Number.MAX_SAFE_INTEGER : 10),
        },
        {
          fieldName: 'Type',
          label: 'Payment Method',
          className: 'col-3',
          type: InputTypesEnum.ClientPaymentTypeLookupTextSelectWithoutPrepayment,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'IsPrepayment',
          label: 'Prepayment?',
          className: 'col-3',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: (item) => CreateTpClientPaymentWindowDescription.getEntryDate(item),
          label: 'Entry Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaymentInstrumentDateUtc',
          label: 'Payment Instrument Date',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'CheckNumber',
          label: 'Payment Ref #',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: CreateTpClientPaymentWindowDescription.forCheckNumberField,
        },
        {
          fieldName: 'AmountPaid',
          label: 'Amount Paid',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
        },
        {
          fieldName: 'ReceivingOfficeId',
          label: 'Receiving Office',
          className: 'col-6',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Notes',
          label: 'Notes',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static getEntryDate(item) {
    item.EntryDateUtc = new Date();
    return item.EntryDateUtc;
  }

  static onClientChange(item) {
    if (item.staticClient !== 0) {
      item.ClientId = item.staticClient;
    }
    return item.ClientId;
  }

  static forCheckNumberField(e, item) {
    if (e && e.length > 30) {
      return 'Check Number must be less than or equal to 30 characters';
    }
    return '';
  }
}
